module.exports = __webpack_public_path__ + "img/clients_img_02_en.762b9c51.jpg";